import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { WarehouseOrderExtraServiceDataForm, WarehouseOrderExtraServiceFilters } from '../../models/WareHouseOrderExtraService';

const useWarehouseOrderExtraService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetWarehouseOrderExtraServices, setFetchingGetWarehouseOrderExtraServices] = useState(false);
    const [fetchingStoreWarehouseOrderExtraService, setFetchingStoreWarehouseOrderExtraService] = useState(false);
    const [fetchingUpdateWarehouseOrderExtraService, setFetchingUpdateWarehouseOrderExtraService] = useState(false);
    const [fetchingDeleteWarehouseOrderExtraService, setFetchingDeleteWarehouseOrderExtraService] = useState(false);
    const [fetchingShowWarehouseOrderExtraService, setFetchingShowWarehouseOrderExtraService] = useState(false);
    const [fetchingEditWarehouseOrderExtraService, setFetchingEditWarehouseOrderExtraService] = useState(false);
    const [fetchingCreateWarehouseOrderExtraService, setFetchingCreateWarehouseOrderExtraService] = useState(false);

    const getAllWarehouseOrderExtraServicesByOrder = (
        quoteId: number,
        extraServiceFilters: WarehouseOrderExtraServiceFilters,
        events: ServiceEvents = {}

    ) => {
       
        const queryString = Object.entries(extraServiceFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_ORDERS.GET_WAREHOUSE_ORDER_EXTRA_SERVICES}?${queryString}`;
       
        doGet({
            ...events,
            url: url.replace(
                ':warehouse_order_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseOrderExtraServices
        });
    };

    const showWarehouseOrderExtraService = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.SHOW_WAREHOUSE_ORDER_EXTRA_SERVICE.replace(':id', id.toString()),
            setFetching: setFetchingShowWarehouseOrderExtraService
        });
    };

    const storeWarehouseOrderExtraService = (
        data: WarehouseOrderExtraServiceDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            url: EndPoints.WAREHOUSE_ORDERS.STORE_WAREHOUSE_ORDER_EXTRA_SERVICE,
            body: data,
            setFetching: setFetchingStoreWarehouseOrderExtraService,
            ...events
        });
    };

    const updateWarehouseOrderExtraService = (
        id: number,
        data: WarehouseOrderExtraServiceDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.UPDATE_WAREHOUSE_ORDER_EXTRA_SERVICE.replace(':id', id.toString()),
            body: data,
            setFetching: setFetchingUpdateWarehouseOrderExtraService
        });
    };

    const deleteWarehouseOrderExtraService = (
        id: number,
        events: ServiceEvents = {}
    ) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.DELETE_WAREHOUSE_ORDER_EXTRA_SERVICE.replace(':id', id.toString()),
            setFetching: setFetchingDeleteWarehouseOrderExtraService
        });
    };

    const createWarehouseOrderExtraService = (quoteId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CREATE_WAREHOUSE_ORDER_EXTRA_SERVICE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingCreateWarehouseOrderExtraService
        });
    };

    const editWarehouseOrderExtraService = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.EDIT_WAREHOUSE_ORDER_EXTRA_SERVICE.replace(':id', id.toString()),
            setFetching: setFetchingEditWarehouseOrderExtraService
        });
    };

    return {
        getAllWarehouseOrderExtraServicesByOrder,
        showWarehouseOrderExtraService,
        storeWarehouseOrderExtraService,
        updateWarehouseOrderExtraService,
        deleteWarehouseOrderExtraService,
        createWarehouseOrderExtraService,
        editWarehouseOrderExtraService,

        fetchingGetWarehouseOrderExtraServices,
        fetchingStoreWarehouseOrderExtraService,
        fetchingUpdateWarehouseOrderExtraService,
        fetchingDeleteWarehouseOrderExtraService,
        fetchingShowWarehouseOrderExtraService,
        fetchingCreateWarehouseOrderExtraService,
        fetchingEditWarehouseOrderExtraService
    };
};

export default useWarehouseOrderExtraService;
